<template>
  <router-view />
</template>

<script>
export default {
  name: 'AssignLoanOfficer'
}
</script>

<style scoped>

</style>
